import TestSuitePanel from "./views/TestSuitePanel";

export default TestSuitePanel;
